module.exports = __webpack_public_path__ + "static/img/08.7221a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/08.png
// module id = 9bt6
// module chunks = 2